import { useCallback } from "react";

import { useProduct } from "contexts/ProductContext";
import { useProductActions } from "hooks/useProductActions";
import { getActionsByType } from "integrations/firebase/collections";
import { actionErrored, actionInProgress } from "utils/status";

export const useMarketingSubtitlesPanelState = () => {
  const { product } = useProduct();
  const { generateSubtitle, errorGenerate, isLoadingGenerate } =
    useProductActions();

  const { subtitle: subtitleActions } = getActionsByType(product);
  const action = subtitleActions?.generate;
  const isGenerating = actionInProgress(action);
  const isError = actionErrored(action);
  const isGenerateDisabled = isLoadingGenerate || isGenerating;

  const handleGenerate = useCallback(async () => {
    if (!product) return;

    await generateSubtitle(product, null);
  }, [generateSubtitle, product]);

  return {
    productId: product?.id,
    subtitles: product?.subtitles,
    onGenerate: handleGenerate,
    isGenerateDisabled,
    hasGenerateError: Boolean(errorGenerate),
    isGenerating,
    isError,
    errorStatusCode: action?.statusCode,
  };
};
